<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
-->

<template>
  <div class="status-dropdown" @mouseleave="closeStatusDropdown">
    <v-btn
      color="primary"
      :loading="statusChangeLoading"
      :disabled="disabled"
      :class="[
        statusInfos[status] && statusInfos[status].class,
        'status-card',
        { 'dropdown-active': showDropdown }
      ]"
      @click.stop="toggleStatusDropdown()"
      ><slot>{{ statusInfos[status] && statusInfos[status].text }}</slot>
      <v-icon right>arrow_drop_down</v-icon>
    </v-btn>

    <ul
      :class="[
        'dropdown-menu',
        'dropdown-options',
        { 'bottom-up': bottomUpDropdown }
      ]"
      v-show="showDropdown"
    >
      <li
        v-for="(statusInfo, _status) in statusInfos"
        :key="_status"
        v-if="status !== _status"
        :class="[statusInfo.class, 'status-card']"
      >
        <a
          href=""
          @click.stop.prevent="
            closeStatusDropdown()
            selectedStatus = _status
            openConfirmdialog()
          "
        >
          {{ statusInfo.text }}</a
        >
      </li>
    </ul>

    <div
      @click.stop
      :class="[
        'dropdown-menu',
        'confirmdialog',
        { 'bottom-up': bottomUpConfirmdialog }
      ]"
      v-if="showConfirmdialog"
    >
      <h3 :class="statusInfos[selectedStatus].class">
        {{ statusInfos[selectedStatus].text }}
      </h3>
      <div class="multiline-text">
        <textarea
          cols="30"
          rows="10"
          placeholder="Add any notes here..."
          v-model="note"
        />
        <div class="actions">
          <v-btn @click="closeConfirmdialog">Cancel</v-btn>
          <v-btn
            color="primary"
            @click="
              closeConfirmdialog()
              $emit('status-change', { note, selectedStatus })
            "
            ><v-icon left>check</v-icon> Save</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusDropdownDialog",
  props: {
    status: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    bottomUpDropdown: {
      type: Boolean,
      default: false
    },
    bottomUpConfirmdialog: {
      type: Boolean,
      default: false
    },
    forceDropdownClosed: {
      type: Boolean,
      default: false
    },
    statusInfos: {
      type: Object,
      default: () => ({})
    },
    statusChangeLoading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showDropdown: false,
    showConfirmdialog: false,
    selectedStatus: null,
    note: ""
  }),

  watch: {
    disabled(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.closeStatusDropdown()
        this.closeConfirmdialog()
      }
    }
  },
  methods: {
    closeStatusDropdown() {
      if (this.showDropdown) {
        this.showDropdown = false
        this.$emit("show-dropdown", false)
      }
    },
    toggleStatusDropdown() {
      if (this.forceDropdownClosed || this.showConfirmdialog) return

      this.showDropdown = !this.showDropdown
      this.$emit("show-dropdown", this.showDropdown)
    },
    openConfirmdialog() {
      this.note = ""
      this.showConfirmdialog = true
      this.$emit("show-confirmdialog", true)
    },
    closeConfirmdialog() {
      this.showConfirmdialog = false
      this.$emit("show-confirmdialog", false)
    }
  }
}
</script>

<style lang="scss" scoped>
.status-dropdown {
  width: fit-content;
  position: relative;

  .status-card.v-btn {
    height: 1.35rem;
    padding-left: 0.35rem;
    padding-right: 0.25rem;

    .v-icon {
      font-size: 1.33em;
      margin-left: 0.25em;
      transition: inherit !important;
      transition-property: transform !important;
    }
    &.dropdown-active .v-icon {
      transform: rotate(180deg);
    }
  }

  ul.dropdown-options {
    list-style: none;
    padding: 0;

    li.status-card {
      font-size: 0.875rem;
      border-radius: 0;
      &:not(:last-child) {
        border-bottom: 1px solid $color-white;
      }
    }

    a {
      color: inherit;
      padding: 0.375rem 0.75rem;
      text-decoration: none;
      display: block;
      &:hover {
        background-color: rgba(0, 0, 0, 0.15);
      }
    }
  }

  .confirmdialog {
    background-color: $color-white;
    h3 {
      @include label-font;
      margin: 0;
      padding: 0.5rem 0.75rem;
    }
    .multiline-text {
      padding: 1.125rem 1.125rem 0.75rem;
      textarea {
        font-size: 1rem;
        resize: none;
        border: 1px solid $color-ec-gray-lighten-2;
        border-radius: 2px;
        width: 13.125rem;
        height: 6rem;
        padding: 0.5rem;
      }
    }
    .actions {
      display: flex;
      justify-content: space-between;
      margin-top: 0.75rem;
      .v-btn {
        @include label-font;
        margin: 0;
        height: 1.875rem;
        color: $color-white;
        min-width: 0;
        padding: 0 0.75rem;
        &:first-child {
          background-color: $color-ec-btn-gray;
        }

        .v-icon--left {
          margin-right: 0.35rem;
          @include label-font;
        }
      }
    }
  }

  .dropdown-menu {
    position: absolute;
    z-index: 1;
    box-shadow: 0 6px 3px 0 rgba(0, 0, 0, 0.23),
      0 10px 10px 0 rgba(0, 0, 0, 0.19);
  }

  .bottom-up {
    top: auto;
    bottom: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StatusDropdownDialog.vue